import React, { useState, useEffect } from "react";
import { fetchJson } from "../api";

const GOLD = "#d4a550";
const GOLD_DIM = "rgba(212,165,80,0.15)";
const GOLD_BORDER = "rgba(212,165,80,0.35)";
const SURFACE = "#12121a";
const BORDER = "rgba(255,255,255,0.07)";
const TEXT = "#e8e6df";
const TEXT_DIM = "rgba(232,230,223,0.45)";

function Avatar({ nome, cognome, size = 26 }) {
  const initials = `${(nome||"")[0]||""}${(cognome||"")[0]||""}`.toUpperCase();
  return (
    <div style={{ width:size, height:size, borderRadius:"50%", background:GOLD_DIM, border:`1px solid ${GOLD_BORDER}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:size*0.38, fontWeight:700, color:GOLD, flexShrink:0 }}>
      {initials||"?"}
    </div>
  );
}

function SearchModal({ onClose, onSelect, planStart, planEnd, defaultRole, productionId }) {
  const [mode, setMode] = useState("search");
  const [q, setQ] = useState("");
  const [role, setRole] = useState(defaultRole || "");
  const [ruoli, setRuoli] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rosaItems, setRosaItems] = useState([]);
  const [veterans, setVeterans] = useState([]);
  const [selected, setSelected] = useState(null);
  const [manual, setManual] = useState("");

  useEffect(() => {
    fetchJson("/postplans/freelancers/roles")
      .then(d => setRuoli(d.roles || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const fromParam = planStart ? `&from=${planStart.slice(0,10)}` : "";
    const toParam = planEnd ? `&to=${planEnd.slice(0,10)}` : "";
    fetchJson(`/postplans/freelancers/search?q=${encodeURIComponent(q)}&role=${encodeURIComponent(role)}${fromParam}${toParam}`)
      .then(d => setResults(d.freelancers || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q, role, planStart, planEnd]);

  useEffect(() => {
    if (mode !== "rosa" || !productionId) return;
    const fromParam = planStart ? `&from=${planStart.slice(0,10)}` : "";
    const toParam = planEnd ? `&to=${planEnd.slice(0,10)}` : "";
    fetchJson(`/postplans/rosa/${productionId}?${fromParam}${toParam}`)
      .then(d => setRosaItems(d.rosa || []))
      .catch(() => {});
    fetchJson("/productions/" + productionId + "/veterans")
      .then(d => setVeterans(d.veterans || [])).catch(() => {});
  }, [mode, productionId]);

  function confirm() {
    if (mode === "search" && selected) {
      onSelect({ label: `${selected.nome} ${selected.cognome}`.trim(), freelancerId: selected.id });
    } else if (mode === "rosa" && selected) {
      const nome = selected.nome ? `${selected.nome} ${selected.cognome||""}`.trim() : selected.name_override;
      onSelect({ label: nome, freelancerId: selected.freelancer_id || null });
    } else if (mode === "manual" && manual.trim()) {
      onSelect({ label: manual.trim(), freelancerId: null });
    }
    onClose();
  }

  const canConfirm = mode === "rosa" ? !!selected : mode === "search" ? !!selected : !!manual.trim();

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:SURFACE, border:`1px solid ${GOLD_BORDER}`, borderRadius:12, width:440, maxHeight:"80vh", display:"flex", flexDirection:"column", overflow:"hidden" }} onClick={e=>e.stopPropagation()}>
        <div style={{ padding:"14px 18px", borderBottom:`1px solid ${BORDER}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ fontWeight:700, color:GOLD }}>Aggiungi persona</span>
          <button onClick={onClose} style={{ background:"none", border:"none", color:TEXT_DIM, cursor:"pointer", fontSize:18 }}>×</button>
        </div>
        {/* Tab */}
        <div style={{ display:"flex", borderBottom:`1px solid ${BORDER}` }}>
          {[["search","Cerca su JKL"],["rosa","Dalla rosa"],["manual","Nome manuale"]].map(([k,l]) => (
            <button key={k} onClick={() => { setMode(k); setSelected(null); }}
              style={{ flex:1, padding:"9px 4px", background:"none", border:"none", borderBottom: mode===k ? `2px solid ${GOLD}` : "2px solid transparent", color: mode===k ? GOLD : TEXT_DIM, fontSize:11, fontWeight:600, cursor:"pointer", transition:"color 0.15s" }}>
              {l}
            </button>
          ))}
        </div>
        <div style={{ overflowY:"auto", scrollbarWidth:"thin", scrollbarColor:"rgba(212,165,80,0.4) transparent", flex:1 }}>
          {mode === "search" && (
            <>
              <div style={{ padding:"10px 14px", borderBottom:`1px solid ${BORDER}`, display:"flex", flexDirection:"column", gap:7 }}>
                <select value={role} onChange={e => setRole(e.target.value)}
                  style={{ width:"100%", background:"#1a1d23", border:`1px solid ${BORDER}`, borderRadius:6, color:TEXT, fontSize:12, padding:"6px 10px", outline:"none", colorScheme:"dark" }}>
                  <option value="">Tutti i ruoli</option>
                  {[...(ruoli.some(r=>r.startsWith('Editor Video'))?['Editor Video']:[]),...ruoli.filter(r=>!r.startsWith('Editor Video'))].sort((a,b)=>a.localeCompare(b,'it')).map(r=><option key={r} value={r}>{r==='Editor Video'?'Editor Video (tutti)':r}</option>)}
                </select>
                <input value={q} onChange={e => setQ(e.target.value)} placeholder="Cerca per nome..."
                  style={{ width:"100%", background:"rgba(255,255,255,0.04)", border:`1px solid ${BORDER}`, borderRadius:6, color:TEXT, fontSize:12, padding:"6px 10px", outline:"none", boxSizing:"border-box" }} />
              </div>
              {loading && <div style={{ padding:16, textAlign:"center", color:TEXT_DIM, fontSize:12 }}>Ricerca...</div>}
              {results.map(f => (
                <div key={f.id} onClick={() => setSelected(f)}
                  style={{ padding:"10px 16px", display:"flex", alignItems:"center", gap:10, cursor:"pointer", borderBottom:`1px solid ${BORDER}`, background: selected?.id===f.id ? GOLD_DIM : "transparent" }}
                  onMouseEnter={e => { if(selected?.id!==f.id) e.currentTarget.style.background="rgba(255,255,255,0.04)"; }}
                  onMouseLeave={e => { if(selected?.id!==f.id) e.currentTarget.style.background="transparent"; }}>
                  <Avatar nome={f.nome} cognome={f.cognome} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:TEXT }}>{f.nome} {f.cognome}</div>
                    {f.ruoli?.length > 0 && <div style={{ fontSize:11, color:TEXT_DIM }}>{f.ruoli.slice(0,3).join(" · ")}</div>}
                    {f.availability === "busy" && <div style={{ fontSize:10, color:"#f87171" }}>● occupato nel periodo</div>}
                    {f.availability === "free" && f.busy_until && <div style={{ fontSize:10, color:"#fb923c" }}>⚠ libero fino al {new Date(f.busy_until).toLocaleDateString("it-IT",{day:"2-digit",month:"short"})}</div>}
                    {f.availability === "free" && !f.busy_until && <div style={{ fontSize:10, color:"#4ade80" }}>● libero per tutto il periodo</div>}
                  </div>
                  {selected?.id===f.id && <span style={{ color:GOLD, fontSize:16 }}>✓</span>}
                </div>
              ))}
              {!loading && results.length === 0 && q && <div style={{ padding:16, textAlign:"center", color:TEXT_DIM, fontSize:12 }}>Nessun risultato</div>}
            </>
          )}
          {mode === "rosa" && (
            <>
              {rosaItems.length === 0 && <div style={{ padding:24, textAlign:"center", color:TEXT_DIM, fontSize:13 }}>Rosa vuota — aggiungi persone dalla pagina Squadre</div>}
              {rosaItems.map(r => {
                const isVet = veterans.some(v => String(v.freelancer_id) === String(r.freelancer_id));
                const nome = r.nome ? `${r.nome} ${r.cognome||""}`.trim() : r.name_override;
                const isSel = selected?.id === r.id;
                return (
                  <div key={r.id} onClick={() => setSelected(r)}
                    style={{ padding:"10px 16px", display:"flex", alignItems:"center", gap:10, cursor:"pointer", borderBottom:`1px solid ${BORDER}`, background: isSel ? GOLD_DIM : "transparent" }}>
                    <Avatar nome={r.nome} cognome={r.cognome} />
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13, fontWeight:600, color:TEXT }}>{nome}</div>
                      {r.ruoli?.length > 0 && <div style={{ fontSize:11, color:TEXT_DIM }}>{r.ruoli.slice(0,2).join(" · ")}</div>}
                      {r.freelancer_id && r.availability === "busy" && <div style={{ fontSize:10,color:"#f87171",marginTop:2 }}>● occupato nel periodo</div>}
                      {r.freelancer_id && r.availability === "soon" && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>● si libera presto</div>}
                      {r.freelancer_id && r.availability === "free" && r.busy_until && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>⚠ libero fino al {new Date(r.busy_until).toLocaleDateString("it-IT",{day:"2-digit",month:"short"})}</div>}
                      {r.freelancer_id && r.availability === "free" && !r.busy_until && <div style={{ fontSize:10,color:"#4ade80",marginTop:2 }}>● libero per tutto il periodo</div>}
                    </div>
                    {isVet && <span style={{ fontSize:10,color:'#f0c878',border:'1px solid rgba(240,200,120,0.35)',borderRadius:4,padding:'1px 5px' }}>⭐ vet</span>}
                    {isSel && <span style={{ color:GOLD, fontSize:16 }}>✓</span>}
                  </div>
                );
              })}
            </>
          )}
          {mode === "manual" && (
            <div style={{ padding:16 }}>
              <div style={{ fontSize:12, color:TEXT_DIM, marginBottom:10 }}>Inserisci il nome della persona anche se non è su JKL.</div>
              <input value={manual} onChange={e => setManual(e.target.value)} placeholder="Es. Mario Rossi"
                style={{ width:"100%", background:"rgba(255,255,255,0.04)", border:`1px solid ${BORDER}`, borderRadius:6, color:TEXT, fontSize:13, padding:"8px 12px", outline:"none", boxSizing:"border-box" }} />
            </div>
          )}
        </div>
        {/* Footer */}
        <div style={{ padding:"12px 16px", borderTop:`1px solid ${BORDER}`, display:"flex", justifyContent:"flex-end", gap:8 }}>
          <button onClick={onClose} style={{ background:"none", border:`1px solid ${BORDER}`, borderRadius:6, color:TEXT_DIM, fontSize:12, padding:"6px 14px", cursor:"pointer" }}>Annulla</button>
          <button onClick={confirm} disabled={!canConfirm}
            style={{ background:GOLD_DIM, border:`1px solid ${GOLD_BORDER}`, borderRadius:6, color:GOLD, fontSize:12, fontWeight:700, padding:"6px 14px", cursor:canConfirm?"pointer":"not-allowed", opacity:canConfirm?1:0.5 }}>
            Conferma
          </button>
        </div>
      </div>
    </div>
  );
}

export default function StepSquadra({ data, onChange, productionId }) {
  const { phases = [], parallelismi = {}, squadra = {}, episodes = [] } = data;
  const [modal, setModal] = useState(null); // { phaseKey, lineNo }

  const planStart = episodes[0]?.arrivalDate || episodes[0]?.txDate || null;
  const planEnd = episodes[episodes.length - 1]?.txDate || null;

  // Sincronizza turni da phases (aggiorna sempre quando phases cambia)
  useEffect(() => {
    const init = { ...squadra };
    let changed = false;
    phases.filter(ph => !MILESTONE_TYPES.has(ph.typeKey)).forEach(ph => {
      const maxLines = getMaxLines(ph);
      const correctTurni = ph.daysPerEpisode || ph.baseDurationDays || 1;
      for (let lineNo = 1; lineNo <= maxLines; lineNo++) {
        const key = getLineKey(ph, lineNo);
        const existing = init[key];
        // Crea chiave mancante o aggiorna turni se phases è cambiato
        if (!existing) {
          init[key] = { label: "", freelancerId: null, turni: correctTurni, startDate: "", endDate: "" };
          changed = true;
        } else if (existing.turni !== correctTurni) {
          init[key] = { ...existing, turni: correctTurni };
          changed = true;
        }
      }
    });
    if (changed) onChange({ squadra: init });
  }, [phases, parallelismi]);

  // Calcola max linee per fase dai parallelismi
  function getMaxLines(ph) {
    const key = ph.typeKey || ph.name;
    let max = ph.defaultLines || 1;
    episodes.forEach(ep => {
      const v = parallelismi[`${ep.episodeNo}_${key}`];
      if (v && v > max) max = v;
    });
    return max;
  }

  function getLineKey(ph, lineNo) {
    return `${ph.typeKey || ph.name}_${lineNo}`;
  }

  function getLine(ph, lineNo) {
    return squadra[getLineKey(ph, lineNo)] || { label: "", freelancerId: null, turni: ph.daysPerEpisode || ph.baseDurationDays || 1, startDate: "", endDate: "" };
  }

  function setLine(ph, lineNo, patch) {
    const key = getLineKey(ph, lineNo);
    const current = getLine(ph, lineNo);
    const newSquadra = { ...squadra, [key]: { ...current, ...patch } };
    onChange({ squadra: newSquadra });
  }

  function handleSelect({ label, freelancerId }) {
    const { ph, lineNo } = modal;
    setLine(ph, lineNo, { label, freelancerId: freelancerId || null });
    setModal(null);
  }

  const MILESTONE_TYPES = new Set(['vis_autore','mod_autore','vis_rete','mod_rete','master']);
  const PHASE_ROLE_MAP = {
    'ingest': 'Ingest',
    'logger': 'Logger',
    'taglio': 'Assistente al montaggio',
    'montaggio': '',
    'finalizzazione': 'Finalizzatore',
    'audio': '',
    'color': 'Colorist',
  };
  function getDefaultRole(ph) {
    return PHASE_ROLE_MAP[ph.typeKey] ?? ph.name;
  }

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
      <div style={{ fontSize:12, color:TEXT_DIM, lineHeight:1.6 }}>
        Assegna le persone alle linee (opzionale) e indica i turni a disposizione per episodio.
      </div>

      {phases
        .filter(ph => !MILESTONE_TYPES.has(ph.typeKey))
        .map(ph => {
          const maxLines = getMaxLines(ph);
          return (
            <div key={ph.typeKey || ph.name}>
              <div style={{ fontSize:11, fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase", color:TEXT_DIM, marginBottom:8 }}>
                {ph.name}
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                {Array.from({ length: maxLines }, (_, i) => {
                  const lineNo = i + 1;
                  const line = getLine(ph, lineNo);
                  return (
                    <div key={lineNo} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", background:"rgba(255,255,255,0.02)", border:`1px solid ${BORDER}`, borderRadius:8 }}>
                      <div style={{ fontSize:11, color:TEXT_DIM, minWidth:16 }}>{lineNo}</div>
                      <div style={{ flex:1, minWidth:0, overflow:"hidden" }}>
                        {line.label ? (
                          <div style={{ display:"flex", alignItems:"center", gap:8, width:"100%" }}>
                            <Avatar nome={line.label.split(" ")[0]} cognome={line.label.split(" ")[1]} />
                            <span style={{ fontSize:13, color:TEXT, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{line.label}</span>
                            <button onClick={() => setLine(ph, lineNo, { label:"", freelancerId:null })}
                              style={{ background:"none", border:"none", color:"rgba(239,68,68,0.5)", cursor:"pointer", fontSize:14, marginLeft:"auto", flexShrink:0 }}>×</button>
                          </div>
                        ) : (
                          <button onClick={() => setModal({ ph, lineNo, defaultRole: getDefaultRole(ph) })}
                            style={{ background:"none", border:`1px dashed ${BORDER}`, borderRadius:6, color:TEXT_DIM, cursor:"pointer", fontSize:12, padding:"6px 12px", width:"100%", textAlign:"left" }}>
                            + Aggiungi persona (linea {lineNo})
                          </button>
                        )}
                      </div>
                      <div style={{ display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                          <span style={{ fontSize:11, color:TEXT_DIM, whiteSpace:"nowrap" }}>Turni/ep:</span>
                          <input type="number" min={1} max={99} value={line.turni}
                            onChange={e => setLine(ph, lineNo, { turni: Math.max(1, parseInt(e.target.value)||1) })}
                            style={{ width:52, background:"rgba(255,255,255,0.04)", border:`1px solid ${GOLD_BORDER}`, borderRadius:6, color:GOLD, fontSize:13, padding:"4px 8px", textAlign:"center", fontWeight:700 }} />
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                          <span style={{ fontSize:11, color:TEXT_DIM, whiteSpace:"nowrap" }}>Dal:</span>
                          <input type="date" value={line.startDate||""}
                            onChange={e => setLine(ph, lineNo, { startDate: e.target.value })}
                            style={{ background:"rgba(255,255,255,0.04)", border:`1px solid rgba(255,255,255,0.12)`, borderRadius:6, color:line.startDate?"#e8e6df":"rgba(232,230,223,0.3)", fontSize:12, padding:"4px 8px", colorScheme:"dark", width:130 }} />
                          {line.startDate && <button onClick={()=>setLine(ph, lineNo, { startDate:"" })}
                            style={{ background:"none", border:"none", color:"rgba(239,68,68,0.5)", cursor:"pointer", fontSize:14, padding:0 }}>×</button>}
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                          <span style={{ fontSize:11, color:TEXT_DIM, whiteSpace:"nowrap" }}>Al:</span>
                          <input type="date" value={line.endDate||""}
                            onChange={e => setLine(ph, lineNo, { endDate: e.target.value })}
                            style={{ background:"rgba(255,255,255,0.04)", border:`1px solid rgba(255,255,255,0.12)`, borderRadius:6, color:line.endDate?"#e8e6df":"rgba(232,230,223,0.3)", fontSize:12, padding:"4px 8px", colorScheme:"dark", width:130 }} />
                          {line.endDate && <button onClick={()=>setLine(ph, lineNo, { endDate:"" })}
                            style={{ background:"none", border:"none", color:"rgba(239,68,68,0.5)", cursor:"pointer", fontSize:14, padding:0 }}>×</button>}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

      {modal && (
        <SearchModal
          planStart={planStart}
          planEnd={planEnd}
          defaultRole={modal?.defaultRole || ""}
          productionId={productionId}
          onClose={() => setModal(null)}
          onSelect={handleSelect}
        />
      )}
    </div>
  );
}
